"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomMetricType = void 0;
var CustomMetricType;
(function (CustomMetricType) {
    CustomMetricType[CustomMetricType["COUNT"] = 1] = "COUNT";
    CustomMetricType[CustomMetricType["RATE"] = 2] = "RATE";
    CustomMetricType[CustomMetricType["GAUGE"] = 3] = "GAUGE";
    CustomMetricType[CustomMetricType["DISTRIBUTION"] = 4] = "DISTRIBUTION";
})(CustomMetricType || (exports.CustomMetricType = CustomMetricType = {}));
//# sourceMappingURL=types.js.map